<template>
  <w-icon-wrapper icon-name='work-filter-add'>
    <g
      id='_43_Filter_hinzufügen_Icon'
      data-name='43 Filter hinzufügen_Icon'
      transform='translate(-0.07)'
    >
      <path
        id='Pfad_55729'
        d='M18.48,8.02,24.07,0,.07.08,8.98,13V24l6.04-2V19.21A6,6,0,1,0,18.48,8.02Zm-5.47,9.31v3.23l-2.02.67V12.38l-.35-.51L3.88,2.07l16.34-.06L15.74,8.44A6.009,6.009,0,0,0,12,14,5.947,5.947,0,0,0,13.01,17.33ZM18,18a4,4,0,0,1-.98-7.87A3.514,3.514,0,0,1,18,10a4,4,0,0,1,0,8Z'
        data-name='Pfad 55729'
        fill='currentColor'
      />
      <path
        id='Pfad_55730'
        d='M19.478,13.463h-1v-1a.5.5,0,0,0-1,0v1h-1a.5.5,0,1,0,0,1h1v1a.5.5,0,0,0,1,0v-1h1a.5.5,0,0,0,0-1Z'
        data-name='Pfad 55730'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconFilterAdd' };
</script>
